import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {BlogsEmLeadsComponent} from './blogs-em-leads.component';

const routes: Routes = [
    {path: 'blogs-em-leads', component: BlogsEmLeadsComponent}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BlogsEmLeadsRoutingModule {
}
